// Used in student-profile.component.ts

import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Asset } from "@carnegie-learning/cure-types";

export interface PreviewAssetDialogData {
    asset: Asset;
}

@Component({
    selector: "preview-asset-dialog",
    templateUrl: "./preview-asset-dialog.component.html",
    styleUrls: ["./preview-asset-dialog.component.scss"],
    standalone: false
})
export class PreviewAssetDialogComponent implements OnInit {
    asset: Asset;

    constructor(
        public dialogRef: MatDialogRef<PreviewAssetDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PreviewAssetDialogData
    ) {}

    ngOnInit() {
        this.asset = <Asset>this.data.asset;
    }

    onCancel() {
        this.dialogRef.close();
    }
}
